<template>
  <div>
    <div class="table-responsive">
      <table
        :id="tableId"
        class="display table table-striped table-bordered tbl-logs"
        style="text-align: center;"
      >
        <thead>
          <tr>
            <th>No.</th>
            <th>Activity</th>
            <th>Timestamp</th>
          </tr>
        </thead>
        <tbody>
          
          <tr v-for="(user, index) in $props.data" v-bind:key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ user.activity }}</td>
            <td>{{ user.created_at }}</td>
          </tr>
        </tbody>
      </table>

      <pagination
        v-show="isNeed"
        v-model="pageInfo.current_page"
        :per-page="pageInfo.per_page"
        :records="pageInfo.total"
        @paginate="handlePageChange"
      />
    </div>
  </div>
</template>


<script>
import Pagination from "vue-pagination-2";

export default {
  components: {
    Pagination
  },

  props: {
    pageInfo: {
      Type: Object,
      required: false,
      default: {
        current_page: 1,
        next_page_url: null,
        previous_page_url: null,
        total: 0,
        count: 0,
        per_page: 0,
        last_page: 0
      }
    },

    data: {
      Type: Array,
      required: true,
      default: []
    },

    tableId: {
      Type: String,
      required: false,
      default: 'tbl-datatable'
    },

    setDatatable: {
      Type: Function,
      required: false,
    },

    isNeed: {
      Type: Boolean,
      required: false,
      default: false
    }
  },

  methods: {
    async handlePageChange(page) {
      this.$emit('paginate', page);
    },
  },

}
</script>
